export default "__VITE_ASSET__DXyt4DkS__"